import { useEffect, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { Button } from 'primereact/button';

export function ClearFiltersButton({
  selectedContentTypeFields,
  onClick,
  gridRef,
}: {
  selectedContentTypeFields: string[];
  onClick: () => void;
  gridRef: React.RefObject<AgGridReact>;
}) {
  const [hasGridFilters, setHasGridFilters] = useState(false);
  const api = gridRef.current?.api;
  useEffect(() => {
    if (!api) {
      return;
    }

    function onFilterChanged() {
      const filters = api?.getFilterModel();
      setHasGridFilters(!!filters && Object.keys(filters).length > 0);
    }

    onFilterChanged();

    api?.addEventListener('filterChanged', onFilterChanged);
    return () => {
      api?.removeEventListener('filterChanged', onFilterChanged);
    };
  }, [api]);

  const hasFiltersActive =
    selectedContentTypeFields.length > 0 || hasGridFilters;

  return (
    <Button
      type="button"
      icon="pi pi-filter-slash"
      severity="secondary"
      disabled={!hasFiltersActive}
      onClick={onClick}
    />
  );
}
